import { Element, InstallSpec, ItemComponent } from "../../../install/types.ts";

const API_KEY_AND_SECRET_PATTERN = /^[a-f0-9]{32}$/;

const orgName = Element({
  label: "Organization name",
  type: "string",
  description: "The organization name",
  validator: async (_id, field) => {
    if (!field) {
      return "Please provide the organization name";
    }
  },
});

const apiKey = (scopeDescription: string) =>
  Element({
    label: "API key",
    type: "string",
    description: `API key with scopes: ${scopeDescription}`,
    validator: async (_id, field) => {
      if (!field) {
        return "Please provide the API key";
      }
      if (!field.trim().match(API_KEY_AND_SECRET_PATTERN)) {
        return "API key must be a 32-character hexadecimal string";
      }
    },
  });

const secretElement = () =>
  Element({
    label: "Secret",
    type: "encrypted",
    description: "Secret of the API key",
    validator: async (_id, field) => {
      if (!field) {
        return "Please provide the secret";
      }
      if (field.clearText?.trim() !== field.clearText) {
        return "Please remove leading and trailing whitespace from the secret";
      }
      if (!field.clearText?.match(API_KEY_AND_SECRET_PATTERN)) {
        return "Secret must be a 32-character hexadecimal string";
      }
    },
  });

export const CsaComponents = InstallSpec({
  "iam-write": ItemComponent({
    label: "Cisco Secure Access policy management",
    description:
      "Allows P0 to manage access to your Cisco Secure Access network for your users.",
    type: "dynamic",
    maturity: "ga",
    schema: {
      apiKey: apiKey(
        '"Policies / Private Resources - Read-Only" and "Policies / Private Resources - Read / Write"'
      ),
      iamWriteSecret: secretElement(),
    },
  }),
  "network-access": ItemComponent({
    label: "Cisco Secure Access network access",
    description: "Allows P0 to read Cisco Secure Access private resources.",
    type: "string",
    maturity: "ga",
    schema: {
      orgName,
      apiKey: apiKey('"Policies / Private Resources - Read-Only"'),
      networkAccessSecret: secretElement(),
    },
  }),
});
